.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);

  padding: var(--space-3) var(--space-4);
  border: 1px solid transparent;
  border-radius: var(--radius-md);

  font-family: var(--font-sans);
  font-size: var(--text-base);
  line-height: var(--leading-relaxed);
  color: var(--text-secondary);
}

.icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  /* Exactly one line tall, so the icon centres against the first line of text
     instead of sitting above it on the flex top edge. */
  height: calc(var(--text-base) * var(--leading-relaxed));
}

/* Sized in em so it tracks the text, and so consumers don't pass a pixel size.
   An unsized SVG is 300x150. */
.icon > svg {
  width: 1.15em;
  height: 1.15em;
}

.content {
  min-width: 0;
}

.title {
  display: block;
  color: var(--text-primary);
  font-weight: var(--weight-semi);
}

/* ── Tones ── */

.info {
  background: var(--color-info-muted);
  border-color: var(--color-info);
}

.info .icon {
  color: var(--color-info);
}

.success {
  background: var(--color-success-muted);
  border-color: var(--color-success);
}

.success .icon {
  color: var(--color-success);
}

.warning {
  background: var(--color-warning-muted);
  border-color: var(--color-warning);
}

.warning .icon {
  color: var(--color-warning);
}

.danger {
  background: var(--color-danger-muted);
  border-color: var(--color-danger);
}

.danger .icon {
  color: var(--color-danger);
}
